export default __webpack_public_path__ + "static/media/ribbon.b85439bb.png";